// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1831":"b97bb3c8","3975":"8effa155","7871":"7533d5a5","9756":"f3c92b3b"}[chunkId] + ".chunk.css";
};